import curdGenerator from "./curdGenerator";

export const mis = [
  {
    module: "MIS",
    children: [
      {
        module: "Reports",
        children: [
          {
            module: "Collection Register",
            permission: "collectionregister",
            children: []
          },
          {
            module: "User Wise Collection Register",
            permission: "userwisecollectionregister",
            children: []
          },
          {
            module: "Doctor Wise Collection Register",
            permission: "doctorwisecollectionregister",
            children: []
          },
          {
            module: "Department Opd Ipd Report",
            permission: "departmentopdipdreport",
            children: []
          },
          {
            module: "Consultant Sharing Report",
            permission: "consultantsharingreport",
            children: []
          },
          {
            module: "Birthday Anniversary Report",
            permission: "birthdayanniversaryreport",
            children: []
          },
          {
            module: "User Wise Edit Report",
            permission: "userwiseeditreport",
            children: []
          },
          {
            module: "User Wise Login Report",
            permission: "userwiseloginreport",
            children: []
          },
          {
            module: "Daily Activity Report",
            permission: "dailyactivityreport",
            children: []
          },
          {
            module: "Patinet History",
            permission: "patienthistory",
            children: []
          },
          {
            module: "User Cash Collection",
            permission: "usercashcollection",
            children: []
          },
          {
            module: "Registration Details Report",
            permission: "registrationdetailsreport",
            children: []
          },
          {
            module: "Yearly Collection Register",
            permission: "yearlycollectionregister",
            children: []
          },
          {
            module: "Net Revenue Report",
            permission: "netrevenuereport",
            children: []
          },
          {
            module: "Date Wise Collection Report",
            permission: "datewisecollectionreport",
            children: []
          },
          {
            module: "Refund Report",
            permission: "refundreport",
            children: []
          }
        ]
      },
      {
        module: "Expense",
        children: [
          curdGenerator("Expense"),
          {
            module: "Expense Report",
            permission: "expensereport",
            children: []
          }
        ]
      }
    ]
  }
];
